import { resetRecoil } from 'recoil-nexus';
import { gameStates } from './gameState';

export const resetGame = () => {
  gameStates.forEach(resetRecoil);
};
